import createRuleDialogController from './dialog/create-alerts-actions/create-alerts-actions.controller';

const createRuleTemplate = require('./dialog/create-alerts-actions/create-alerts-actions.html');

export default class AlertsActionsNavController {
    /** @ngInject */
    constructor(EventEmitter, DialogService) {
        this.eventEmitter = EventEmitter;
        this.DialogService = DialogService;
    }

    $onInit() {
        this.filterRule = '';
        this.currentRule = null;
        this.addFocus = false;
    }

    $onChanges(changes) {
        if (changes.alertsActions.currentValue) {
            this.alertsActions = changes.alertsActions.currentValue;
        }
    }

    onSelect(rule) {
        this.currentRule = rule;

        this.onPushCurrent(
            this.eventEmitter({
                rule: this.currentRule
            })
        );
    }

    create(ev, typeOfRule) {
        const config = {
            type: typeOfRule
        };

        // TODO: should be implement after update real API
        this.DialogService.show({
            controller: createRuleDialogController,
            controllerAs: '$ctrl',
            template: createRuleTemplate,
            parent: document.body,
            targetEvent: ev,
            openFrom: 'top',
            closeTo: 'top',
            clickOutsideToClose: true,
            escapeToClose: true,
            fullscreen: true,
            locals: {
                rules: this.alertsActions,
                config
            }
        });
    }

    getFilterRules({ query }) {
        this.filterRule = query;
    }
}



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions-nav/alerts-actions-nav.controller.js